import { useConsultation } from "@/context/ConsultationContext";
import { CTA_LABEL } from "@/data/content";
import { Overline, CornerOrnaments } from "@/components/GoldDivider";

export default function CtaSection() {
  const { openConsultation } = useConsultation();
  return (
    <section className="velvet-deep py-24 sm:py-32 px-6 relative overflow-hidden" data-testid="cta-section">
      <CornerOrnaments size={150} opacity={0.5} />
      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center">
        <img src="/logo-monogram.png" alt="West Ouachita Cabinets" className="h-20 w-auto rounded-[2px] ring-1 ring-gold/30 mb-8" />
        <Overline>Your Kitchen Starts With A Conversation</Overline>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-ivory mt-5 leading-tight">
          See it in 3D before we build a thing.
        </h2>
        <p className="text-[#A9B7CE] text-lg mt-6 max-w-2xl mx-auto leading-relaxed">
          No pressure, no cost. Just a real conversation about your space and a design you can see.
        </p>
        <button
          data-testid="cta-section-button"
          onClick={openConsultation}
          className="mt-10 bg-gold text-navy-deep font-semibold tracking-luxe uppercase text-sm px-10 py-5 rounded-none hover:bg-gold-light transition-colors duration-300"
        >
          {CTA_LABEL}
        </button>
      </div>
    </section>
  );
}
